import React, {
  useEffect,
  // useRef,
  useState,
} from "react";
import {
  // Animated,
  // Easing,
  // Image,
  // StyleSheet,
  // Text,
  View,
} from "react-native";
import { connect } from "react-redux";
import { setItems } from "../../actions/items";
import { fetchApi } from "../../api";
// import { STYLES } from "../../assets/styles";
// import { SCREEN_HEIGHT } from "../../common";
import Container from "../../components/Container";
import Errors from "../../components/Errors";
import FashionOptions from "../../components/FashionOptions";
import Header from "../../components/Header";
import Items from "../../components/Items";
import Loading from "../../components/Loading";
// import Swiper from "../../components/Swiper";

function Home({ navigation, setItems, userItemFilter }) {
  const [isLoadng, setIsLoading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState({});
  // const scrollY = useRef(new Animated.Value(0)).current;

  const getItems = ({ className, catagories = [], type }) => {
    if (type) {
      let path = `/items?class=${className}&catagory=${catagories.toString()}&type=${type}`;
      return fetchApi({
        path,
      }).then((res) => {
        if (res.results) {
          setItems(res.results);
          return;
        }
        throw res;
      });
    }
    return [];
  };

  useEffect(() => {
    setIsReady(false);
    handleGetItems(userItemFilter.itemsFilter, "New Arrival").then(() => {
      setIsReady(true);
    });
  }, [userItemFilter]);

  const handleGetItems = (filterOption, type) => {
    setIsLoading(true);
    return getItems({
      type,
      className: filterOption.class,
      catagories: Object.keys(filterOption.catagories),
    })
      .then(() => setIsLoading(false))
      .catch((e) => setError({ error: e.error, itemType: type }));
  };

  // const offers = [
  //   {
  //     imageUrl:
  //       "https://images.meesho.com/images/products/10498461/ac2d5_256.jpg",
  //     mainText: "30% off",
  //     description: "for New Users",
  //   },
  //   {
  //     imageUrl:
  //       "https://images.meesho.com/images/products/10498461/ac2d5_256.jpg",
  //     mainText: "30% off",
  //     description: "for New Users",
  //   },
  //   {
  //     imageUrl:
  //       "https://images.meesho.com/images/products/10498461/ac2d5_256.jpg",
  //     mainText: "30% off",
  //     description: "for New Users",
  //   },
  // ];

  // const Item = ({ data: { imageUrl, mainText, description } }) => (
  //   <View
  //     style={{
  //       width: "100%",
  //       height: "100%",
  //     }}
  //   >
  //     <Image
  //       source={{ uri: imageUrl }}
  //       style={{
  //         width: "100%",
  //         height: "100%",
  //         position: "absolute",
  //         top: 0,
  //         left: 0,
  //       }}
  //     />
  //     <View
  //       style={{
  //         backgroundColor: STYLES.colors.black + "40",
  //         flex: 1,
  //         flexDirection: "row",
  //       }}
  //     >
  //       <View
  //         style={{
  //           alignSelf: "center",
  //           paddingHorizontal: 15,
  //         }}
  //       >
  //         <Text
  //           style={{
  //             fontSize: STYLES.fontSizes.xxlarge * 1.6,
  //             color: STYLES.colors.white,
  //           }}
  //         >
  //           {mainText}
  //         </Text>
  //         <Text
  //           style={{
  //             fontSize: STYLES.fontSizes.xlarge,
  //             color: STYLES.colors.white,
  //           }}
  //         >
  //           {description}
  //         </Text>
  //       </View>
  //     </View>
  //   </View>
  // );

  // const opacity = scrollY.interpolate({
  //   inputRange: [0, SCREEN_HEIGHT * 0.4],
  //   outputRange: [1, 0],
  //   extrapolate: "clamp",
  //   easing: Easing.inOut(Easing.linear),
  // });

  // const height = scrollY.interpolate({
  //   inputRange: [0, SCREEN_HEIGHT * 0.4],
  //   outputRange: [SCREEN_HEIGHT * 0.25, 0],
  //   extrapolate: "clamp",
  //   easing: Easing.inOut(Easing.linear),
  // });

  return (
    <Container>
      <Header navigation={navigation} />
      <View style={{ flex: 1 }}>
        {/* <Animated.View style={{ opacity: opacity, height: height }}>
            <Swiper
              style={styles.offersContainer}
              dataArray={offers}
              showPagination={false}
              renderItem={({ item, index }) => <Item data={item} key={index} />}
            />
          </Animated.View> */}
        {isReady ? (
          <>
            <FashionOptions
              onChange={(type) =>
                handleGetItems(userItemFilter.itemsFilter, type)
              }
            />
            {!error.error ? (
              !isLoadng ? (
                <Items
                  onItemPress={({ _id }, index) => {
                    navigation.navigate("tabs", {
                      screen: "home",
                      params: { screen: "item", params: { id: _id } },
                    });
                  }}
                  navigation={navigation}
                  // onScroll={Animated.event(
                  //   [
                  //     {
                  //       nativeEvent: { contentOffset: { y: scrollY } },
                  //     },
                  //   ],
                  //   { useNativeDriver: false }
                  // )}
                />
              ) : (
                <Loading />
              )
            ) : (
              <Errors
                error={error.error}
                onPress={() => {
                  handleGetItems(userItemFilter.itemsFilter, error.itemType);
                  setError({});
                }}
              />
            )}
          </>
        ) : (
          <Loading />
        )}
      </View>
    </Container>
  );
}

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//   },
//   offersContainer: {
//     height: "100%",
//   },
// });

const mapStateToProps = (state) => ({
  userItemFilter: state.filter.userOption,
});

const mapDispatchToProps = (dispatch) => ({
  setItems: (data) => dispatch(setItems(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
